<template>
  <div class="text-overflow ml-tiny mr-auto" style="width: 200px">
    <span class="scroll-item" :class="{ 'is-active-project': active }">
      {{ title }}
    </span>
  </div>
  <ak-tooltip
    v-if="isOwnAccount() && favorite"
    placement="right"
    class="mr-tiny flex"
  >
    <template #trigger>
      <ak-icon type="heart" color="danger" />
    </template>
    Favorite
  </ak-tooltip>
  <div v-if="hidden || activity" class="ak-badge-wrapper mr-tiny">
    <ak-tooltip placement="right" class="flex">
      <template #trigger>
        <ak-badge v-if="activity" color="quaternary" />
        <ak-badge v-if="hidden" color="grey-light" />
      </template>
      <ak-pack v-if="activity" spacing="tiny" class="text-small">
        <ak-pack-item>
          <ak-badge color="quaternary" border="transparent" />
        </ak-pack-item>
        <ak-pack-item> Project managed by Natives </ak-pack-item>
      </ak-pack>
      <ak-pack v-if="hidden" spacing="tiny" class="text-small">
        <ak-pack-item>
          <ak-badge color="grey-light" border="transparent" />
        </ak-pack-item>
        <ak-pack-item> Only visible to Agency Users </ak-pack-item>
      </ak-pack>
    </ak-tooltip>
  </div>
</template>

<script>
import { defineComponent, inject } from 'vue'
import Badge from '@akerolabs/akero-vue/src/components/badge/Badge.vue'
import Pack from '@akerolabs/akero-vue/src/components/pack/Pack.vue'
import PackItem from '@akerolabs/akero-vue/src/components/pack/PackItem.vue'
import Tooltip from '@akerolabs/akero-vue/src/components/tooltip/Tooltip.vue'
import Icon from '@akerolabs/akero-vue/src/components/icon/Icon.vue'
export default defineComponent({
  name: 'TreeDisplayItem',
  components: {
    [Badge.name]: Badge,
    [Pack.name]: Pack,
    [PackItem]: PackItem,
    [Tooltip.name]: Tooltip,
    [Icon.name]: Icon,
  },
  props: {
    title: {
      type: String,
      default: undefined,
    },
    favorite: {
      type: Boolean,
      default: false,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    activity: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const isOwnAccount = inject('isOwnAccount')
    return {
      isOwnAccount,
    }
  },
})
</script>
